import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import InquiryHero from "./components/InquiryHero";
import InquiryForm from "./components/InquiryForm";

export default function Inquiry() {
  return (
    <div className="bg-deepblack min-h-screen">
      <Navbar />
      <main>
        <InquiryHero />
        <InquiryForm />
      </main>
      <Footer />
    </div>
  );
}